"use client";

// Filterkopf der Nachrichtenliste — aus dem Listen-Baukasten
// (`components/liste`), wie die Briefliste im Agent.
import {
  Filterkopf,
  Filterzurueck,
  Fuge,
  Luecke,
  Schiene,
  Suchfeld,
  useAnsicht,
  Zaehlknopf,
  Zaehlschiene,
} from "@/components/liste";
import { ALLE_PARAMS, KANAL_FILTER, STATUS_FILTER, ZWECK_FILTER, aktiveFilter, type Ansicht } from "@/lib/nachrichten/ansicht";

export function NachrichtenFilterkopf({
  ansicht,
  gesamt,
  statusZaehler,
  kanalZaehler,
  zweckZaehler,
}: {
  ansicht: Ansicht;
  gesamt: number;
  statusZaehler: Record<string, number>;
  kanalZaehler: Record<string, number>;
  zweckZaehler: Record<string, number>;
}) {
  const { setzen, isPending } = useAnsicht();

  return (
    <Filterkopf
      isPending={isPending}
      oben={
        <>
          <Suchfeld wert={ansicht.q} platzhalter="Betreff, Text, Gruppe …" beschriftung="Nachrichten durchsuchen" />
          <Luecke />
          <Zaehlschiene titel="Status">
            <Zaehlknopf
              label="Alle"
              sammel
              anzahl={gesamt}
              aktiv={ansicht.status === ""}
              titel="Alle Nachrichten"
              onClick={() => setzen({ status: null })}
            />
            <Fuge />
            {STATUS_FILTER.map((s) => (
              <Zaehlknopf
                key={s.schluessel}
                label={s.label}
                anzahl={statusZaehler[s.schluessel] ?? 0}
                aktiv={ansicht.status === s.schluessel}
                ton={s.schluessel === "fehler" ? "gefahr" : "normal"}
                titel={s.hinweis}
                onClick={() => setzen({ status: ansicht.status === s.schluessel ? null : s.schluessel })}
              />
            ))}
          </Zaehlschiene>
        </>
      }
      unten={
        <>
          <Zaehlschiene titel="Kanal">
            {KANAL_FILTER.map((k) => (
              <Zaehlknopf
                key={k.schluessel}
                label={k.label}
                anzahl={kanalZaehler[k.schluessel] ?? 0}
                aktiv={ansicht.kanal === k.schluessel}
                onClick={() => setzen({ kanal: ansicht.kanal === k.schluessel ? null : k.schluessel })}
              />
            ))}
          </Zaehlschiene>
          <Schiene>
            {ZWECK_FILTER.map((z) => (
              <Zaehlknopf
                key={z.schluessel}
                label={z.label}
                anzahl={zweckZaehler[z.schluessel] ?? 0}
                aktiv={ansicht.zweck === z.schluessel}
                titel={z.hinweis}
                onClick={() => setzen({ zweck: ansicht.zweck === z.schluessel ? null : z.schluessel })}
              />
            ))}
          </Schiene>
          <Filterzurueck anzahl={aktiveFilter(ansicht)} params={ALLE_PARAMS} />
        </>
      }
    />
  );
}
